var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustManageDataCyan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 5,
    rx: 7,
    ry: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5v6c0 1.4 3.1 2.5 7 2.5s7-1.1 7-2.5V5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11v6c0 1.4 3.1 2.5 7 2.5s7-1.1 7-2.5v-6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustManageDataCyan);
export default __webpack_public_path__ + "static/media/trust-manage-data-cyan.9014b46d85879839baa2e453f1dcbea4.svg";
export { ForwardRef as ReactComponent };